import { GeneratedTripCountrySourceType } from 'app/constants/configuration/generatedTripCountrySourceType'

export const getGeneratedTripCountrySourceTypeName = (
  generatedTripCountrySourceType: GeneratedTripCountrySourceType,
  translate: (string) => string,
): string => {
  const text: string =
    GeneratedTripCountrySourceType[generatedTripCountrySourceType]
  return translate(`generatedTripCountrySourceType.${text}`)
}
